import axios from "axios";
import { Base_URL } from "../url";

export const fetchProjectResourceMappings = async () => {
  try {
    const response = await axios.get(`${Base_URL}/ProResMapping/GetAllMappings`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching project resource mappings!";
  }
};

export const downloadMappingsExcel = async () => {
  try {
    const response = await axios.post(
      `${Base_URL}/ProResMapping/DownloadMappingsExcel`,
      null, 
      {
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
      }
    );
    return response;
  } catch (error) {
    throw error.response?.data || "Error downloading project resource mappings data!";
  }
};